import { requestUrl } from "@/config/config";
// 发票记录
export const invoiceRecord = (ids) =>
  `${requestUrl}/manage/invoice/record?ids=${ids}`;
